<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre1" id="Mercurys_Rise-3.html" xml:lang="en-US">
<div class="calibre1">
<p class="ct" id="toc_marker-4"><a href="#/OEBPS/Mercurys_Rise2#Contents-A">Dedication</a></p>
<p class="body-center1"><em class="italic">Dedicated to sisters, and especially to<br class="calibre3"/>Alison<br class="calibre3"/>With love and hugs, stretching over the miles and over the years.</em></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Mercurys_Rise-3.vue?055b9c28